import { render, staticRenderFns } from "./Localizer.vue?vue&type=template&id=1fa92b41"
import script from "./Localizer.vue?vue&type=script&lang=js"
export * from "./Localizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports